import React from "react";
import clsx from "clsx";

type SectionPadding = "none" | "sm" | "md" | "lg";
type SectionHeight = "auto" | "screen";

interface SectionProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {
    children: React.ReactNode;
    /**
     * Vertical height behavior
     * - auto: height fits content
     * - screen: min-height = 100vh
     */
    height?: SectionHeight;

    /**
     * Optional background utility class
     * Example: "bg-bg-page", "bg-black"
     */
    className?: string;
}

export default function Section({ children, height = "auto", className, ...props }: SectionProps) {
    return (
        <section className={clsx(height === "screen" && "min-h-screen tracking-tight", className)} {...props}>
            <div className={"mx-auto px-8 lg:px-24 py-20 sm:py-24 lg:py-28"}>{children}</div>
        </section>
    );
}
